import moment from "moment";
import React, { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner, Table } from "reactstrap";

export const ButtonPrint = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

const PAGE_ROW_LIMIT = 90;

const cellStyle = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  verticalAlign: "top",
  wordWrap: "break-word",
};

export const PrintDocExpense = ({ innerRef, item }) => {
  const validValue = (val) => {
    return <span className="courier-prime-bold text-capitalize">{`${val || "..................."}`}</span>;
  };

  const handleValidDate = (date) => {
    return moment(date).format("DD/MM/YYYY");
  };
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  return !item || item === undefined || item === null ? (
    <></>
  ) : (
    <div
      // className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} style={{ padding: "60px 80px", fontSize: "14px", fontFamily: "serif", color: "#000" }}>
        <table
          border="1"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontFamily: "serif",
            fontSize: "14px",
            lineHeight: "18px",
            backgroundColor: "#e6f2e6",
            marginBottom: "20px",
          }}
        >
          <tbody>
            {/* Baris Hijau Atas */}
            <tr style={{ backgroundColor: "#6aa84f", color: "#000" }}>
              <td colSpan="4" style={{ height: "20px" }}></td>
            </tr>
            <tr>
              <td colSpan="2" style={{ fontWeight: "bold", textAlign: "center" }}>
                PT. HIKMAH ALAM SENTOSA
              </td>
              <td style={{ whiteSpace: "nowrap" }}>No. Dokumen</td>
              <td>: HAS-SOP-01.12 ACC.01.02</td>
            </tr>

            {/* Baris SOP */}
            <tr>
              <td colSpan="2" rowSpan="4">
                <div style={{ textAlign: "center", fontWeight: "bold" }}>STANDARD OPERATING PROCEDURE</div>
                <div style={{ textAlign: "center", color: "#0070c0" }}>
                  Pengeluaran Uang untuk Kebutuhan Operasional <br />
                  Perusahaan
                </div>
                <div style={{ textAlign: "center" }}>Lampiran : Form Permintaan Pembayaran</div>
              </td>
              <td>Mulai Berlaku</td>
              <td>: {validValue(handleValidDate(item.transactionat))}</td>
            </tr>
            <tr>
              <td>Revisi</td>
              <td>: 00</td>
            </tr>
            <tr>
              <td>Tanggal Revisi</td>
              <td>: -</td>
            </tr>
            <tr>
              <td>Halaman </td>
              <td>: 2 dari 3</td>
            </tr>
          </tbody>
        </table>

        {/* Body */}
        <div
          style={{
            fontWeight: "bold",
          }}
        >
          <span>(Form Permintaan Pembayaran)</span>
          <div
            style={{
              height: "1px",
              backgroundColor: "black",
              width: "100%",
              marginBottom: "10px",
            }}
          ></div>
        </div>

        <p>
          <b>Nomor</b> : CD-..... &nbsp;&nbsp;&nbsp; <i>(UK/............../01.12/2021 - Diisi oleh Accounting)</i>
        </p>

        <span>Yth, Bagian Keuangan</span>
        <br></br>
        <span>Bersama ini kami mohon pembayaran tagihan operasional perusahaan dengan rincian data sebagai berikut:</span>

        <div
          style={{
            marginTop: "10px",
            fontWeight: "bold",
          }}
        >
          <span>
            <i>{item.description}</i>
          </span>
          <div
            style={{
              height: "1px",
              backgroundColor: "black",
              width: "100%",
              marginBottom: "10px",
            }}
          ></div>
        </div>

        <table style={{ marginBottom: "10px" }}>
          <tbody>
            <tr>
              <td style={{ width: "180px", verticalAlign: "top" }}>Pilihan</td>
              <td
                style={{
                  fontWeight: "bold",
                }}
              >
                : {validValue(item.at_tag?.name)}
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: "top" }}>Jumlah Pembayaran</td>
              <td>: . {validValue("Rp " + currencyFormat(item.amount))}</td>
            </tr>
            <tr>
              <td style={{ verticalAlign: "top" }}>Nilai penyelesaian </td>
              <td>: ....................................................</td>
            </tr>
          </tbody>
        </table>
        <em>{validValue(numberToWords(item.amount, "Rupiah"))}</em>
        <hr style={{ margin: "10px 0", borderTop: "1px solid black" }} />

        <p>Dokumen Penggunaan di lampirkan apabila telah menyelesaikan kegiatan operasional.</p>
        <p>
          Demikian surat permintaan pembayaran ini disampaikan dan <u>diucapkan terima kasih atas kerja samanya.</u>
        </p>
        <span>Tanggal: {validValue(handleValidDate(item.transactionat))}</span>

        <br />
        <span>Hormat Kami,</span>

        <p style={{ marginTop: "80px" }}>
          <i>{validValue("")}</i>
          {/* <i>{validValue(item?.at_createdby?.name)}</i> */}
        </p>

        {/* /// */}
        <div className="pagebreak">
          <style>{`@media print{.pagebreak{page-break-after:always;}}`}</style>
        </div>
        <div style={{ paddingTop: "40px" }}>
          <table
            border="1"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontFamily: "serif",
              fontSize: "14px",
              backgroundColor: "#e6f2e6",
              marginBottom: "20px",
            }}
          >
            <tbody>
              {/* Baris Hijau Atas */}
              <tr style={{ backgroundColor: "#6aa84f", color: "#000" }}>
                <td colSpan="4" style={{ height: "20px" }}></td>
              </tr>
              <tr>
                <td colSpan="2" style={{ fontWeight: "bold", textAlign: "center" }}>
                  PT. HIKMAH ALAM SENTOSA
                </td>
                <td style={{ whiteSpace: "nowrap" }}>No. Dokumen</td>
                <td>: HAS-SOP-01.12 ACC.01.02</td>
              </tr>

              {/* Baris SOP */}
              <tr>
                <td colSpan="2" rowSpan="4">
                  <div style={{ textAlign: "center", fontWeight: "bold" }}>STANDARD OPERATING PROCEDURE</div>
                  <div style={{ textAlign: "center", color: "#0070c0" }}>
                    Pengeluaran Uang untuk Kebutuhan Operasional <br />
                    Perusahaan
                  </div>
                  <div style={{ textAlign: "center" }}>Lampiran : Form Permintaan Pembayaran</div>
                </td>
                <td>Mulai Berlaku</td>
                <td>: {validValue(handleValidDate(item.transactionat))}</td>
              </tr>
              <tr>
                <td>Revisi</td>
                <td>: 00</td>
              </tr>
              <tr>
                <td>Tanggal Revisi</td>
                <td>: -</td>
              </tr>
              <tr>
                <td>Halaman </td>
                <td>: 3 dari 3</td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              fontWeight: "bold",
            }}
          >
            <span>Rincian dokumen Penyelesaian / Tagihan / Bukti Transaksi</span>
            <div
              style={{
                height: "1px",
                backgroundColor: "black",
                width: "100%",
                marginBottom: "10px",
              }}
            ></div>
          </div>
          <table style={{ marginBottom: "10px" }}>
            <tbody>
              <tr>
                <td style={{ width: "180px", verticalAlign: "top" }}>No</td>
                <td>: ...................................................</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Invoice</td>
                <td>: ....................................................</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Tanggal</td>
                <td>: ....................................................</td>
              </tr>
            </tbody>
          </table>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              border: "1px solid black",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "6px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  KETERANGAN
                </th>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "6px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  JUMLAH
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Baris kosong untuk isi */}
              <tr style={{ height: "80px" }}>
                <td style={{ border: "1px solid black", padding: "10px" }}>{item.description}</td>
                <td style={{ border: "1px solid black", padding: "10px" }}>{validValue("Rp " + currencyFormat(item.amount))}</td>
              </tr>

              {/* Jumlah */}
              <tr>
                <td style={{ border: "1px solid black", textAlign: "right", padding: "4px" }}>
                  <i>Jumlah</i>
                </td>
                <td style={{ border: "1px solid black", padding: "10px" }}>{validValue("Rp " + currencyFormat(item.amount))}</td>
              </tr>

              {/* PPN */}
              <tr>
                <td style={{ border: "1px solid black", textAlign: "right", padding: "4px" }}>PPN 10%</td>
                <td style={{ border: "1px solid black", textAlign: "right", padding: "4px" }}>0</td>
              </tr>
              {/* Jumlah Total */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "right",
                    fontWeight: "bold",
                    padding: "4px",
                  }}
                >
                  Jumlah Total
                </td>
                <td style={{ border: "1px solid black", padding: "10px" }}>{validValue("Rp " + currencyFormat(item.amount))}</td>
              </tr>
            </tbody>
          </table>
          <span>Bogor: {validValue(handleValidDate(item.transactionat))}</span>
          <p style={{ marginTop: "60px" }}>......................................................</p>
        </div>
      </div>
      {/* /// */}
    </div>
  );
};
